import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as _ from 'lodash';

import { VersionsService } from '../versions.service';


@Component({
  moduleId: module.id,
  selector: 'versions-component',
  templateUrl: 'versions.component.html',
  styleUrls: ['versions.component.scss']
})
export class VersionsComponent implements OnInit, OnDestroy {

  @Input() versionNames: Array<string> = ['VCdb', 'Qdb', 'PAdb', 'PCdb'];

  versions: any;
  private versionsSubscription: any;

  constructor(
    private versionsService: VersionsService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    this.versionsSubscription = this.versionsService.getVersions()
    .subscribe((versions: any) => {
      this.versions = versions;
    });
  }

  ngOnDestroy() {
    if (this.versionsSubscription) { this.versionsSubscription.unsubscribe(); }
  }

  public getLinkText(version: string): string {
    if (this.versions[version]) {
      return this.datePipe.transform(this.versions[version], 'MMM d, y');
    }
    return '';
  }
}
